// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gHwi","colBig":"styles_colBig__3MrHf","colSmall":"styles_colSmall__19Ldu","shopifyNameWrapper":"styles_shopifyNameWrapper__1mkNM"};